<template>
    <App title="Orders">
        <div class="row">
            <div class="col">
                <Block>
                    <template #header>
                        <h3 class="block-title">Orders</h3>
                    </template>
                    <Datatable :options="options" />
                </Block>
            </div>
        </div>
    </App>
</template>

<script lang="ts">
import Block from '@/vue/components/Block.vue'
import { CellRender } from '@/vue/components/Datatable'
import Datatable from '@/vue/components/Datatable.vue'
import App from '@/vue/templates/App.vue'
import { Config } from 'datatables.net-bs5'
import { Component, toNative, Vue } from 'vue-facing-decorator'

@Component({
    components: {
        App,
        Block,
        Datatable,
    },
})
class Group extends Vue {
    get buttons() {
        let buttons: any[] = []
        buttons.push('refresh')
        buttons.push('trashed')

        return buttons
    }

    get columns() {
        let columns: any[] = []
        columns.push({
            data: 'id',
            orderable: true,
            name: 'id',
            title: 'Id',
        })

        columns.push({
            data: 'user.fullname',
            title: 'Name',
            orderable: false
        })
        columns.push({
            name: 'code',
            data: 'code',
            title: 'Code',
            orderable: true
        })

        columns.push({
            'name': 'amount',
            data: 'amount',
            title: 'amount',
            render: CellRender.money(),
            orderable: true
        })

        columns.push({
            data: 'quantity',
            title: 'Quantity',
            name: 'quantity',
            orderable: true
        })

        columns.push({
            name: 'created_at',
            data: 'created_at',
            title: 'Created',
            render: CellRender.date(),
            orderable: true
        })

        return columns
    }

    get options(): Config {
        return {
            ajax: {
                url: this.route('order.ajax.table'),
                method: 'POST',
            },
            buttons: this.buttons,
            columns: this.columns,
            order: [[5, 'desc']]
        }
    }
}

export default toNative(Group)
</script>
